import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CoresService } from 'app/shared/cores.service';
import { WP_API_URL } from 'app/config';

import { PesquisarNoticiaPayload, NoticiaMedia, Tag } from 'models/noticia';

const POSTS_API_URL = WP_API_URL + '/posts';
const TAGS_API_URL = WP_API_URL + '/tags';

@Injectable()
export class NoticiasService {

  private tagsCache: Tag[] = [];

  constructor(
    private cores: CoresService,
    private _http: HttpClient,
  ) { }

  query(params): Promise<PesquisarNoticiaPayload> {
    const requestParams = { '_embed': true, ...params };
    if (!requestParams.tags || !Number.isInteger(requestParams.tags)) {
      delete requestParams.tags;
    }

    // TODO Refinar a forma de remover os parâmetros null e undefined (Talvez no interceptor de requests)
    for (const paramKey in requestParams) {
      if (requestParams[paramKey] === null || requestParams[paramKey] === undefined) {
        delete requestParams[paramKey];
      }
    }

    return new Promise<PesquisarNoticiaPayload>((resolvido, rejeitado) => {
      const POST_FILTER = POSTS_API_URL + '?_embed=true&categories=1';
      this._http.get(POST_FILTER, { params: requestParams, observe: 'response' }).subscribe(

        async (data: any) => {
          try {
            await this.tags();
            let total = 0;
            let totalPaginas = 0;
            if (data) {
              total = this.wpHeadersTotal(data.headers);
              totalPaginas = Number(data.headers.getAll('X-WP-TotalPages'));
            }
            const response = data.body.map(post => this.postToNoticia(post));
            resolvido(new PesquisarNoticiaPayload({ data: response, total, totalPaginas }));
          } catch (error) {
            rejeitado(error);
          }
        },

        err => {
          rejeitado(err);
        },
      );

    });
  }

  tags(): Promise<Tag[]> {
    return new Promise<Tag[]>((resolvido, rejeitado) => {
      if (this.tagsCache.length) {
        resolvido(this.tagsCache);
      } else {
        this._http.get(`${TAGS_API_URL}?per_page=9999`)
          .subscribe(resp => {
            this.tagsCache = this.gerarCorTags(resp);
            resolvido(this.tagsCache);
          });
      }
    });
  }

  getMedia(noticia): NoticiaMedia {
    if (!noticia.featuredMedia) {
      return null;
    }

    if (noticia.featuredMedia.canvas) {
      return noticia.featuredMedia.canvas;
    }

    if (noticia.featuredMedia.thumbnail) {
      return noticia.featuredMedia.thumbnail;
    }

    if (noticia.featuredMedia.full) {
      return noticia.featuredMedia.full;
    }

    return null;
  }

  /********************
   * MÉTODOS PRIVADOS *
   ********************/

  private wpHeadersTotal(headers): number {
    let total = 0;
    if (headers['X-WP-Total']) {
      total = headers['X-WP-Total'][0];
    } else if (headers['x-wp-total']) {
      total = headers['x-wp-total'][0];
    } else if (headers.getAll('X-WP-Total')) {
      total = headers.getAll('X-WP-Total');
    }

    return Number(total);
  }

  private postToNoticia(post) {
    const noticia: any = {};
    noticia.id = post.id;
    noticia.date = post.date;
    noticia.slug = post.slug;
    noticia.title = post.title;
    noticia.content = post.content;
    noticia.excerpt = post.excerpt;

    if (post._embedded) {

      // author
      if (post._embedded.author && post._embedded.author[0]) {
        noticia.author = {
          id: post._embedded.author[0].id,
          name: post._embedded.author[0].name,
        };
      }

      // featuredMedia
      if (post._embedded['wp:featuredmedia'] && post._embedded['wp:featuredmedia'][0] &&
          post._embedded['wp:featuredmedia'][0].media_details &&
          post._embedded['wp:featuredmedia'][0].media_details.sizes) {
        const media = post._embedded['wp:featuredmedia'][0].media_details.sizes.noticia_full || post._embedded['wp:featuredmedia'][0].media_details.sizes.full;
        noticia.featuredMedia = {
          canvas: media,
          thumbnail: media,
          full: media,
        };
      }

      // tags
      if (post._embedded['wp:term'] && post._embedded['wp:term'][1]) {
        noticia.tags = post._embedded['wp:term'][1].map(tag => {
          tag.color = this.pegarCorTagPorID(tag.id);
          return tag;
        });
      }
    }
    return noticia;
  }

  private pegarCorTagPorID(id): string {
    return this.tagsCache.find((tag) => tag.id === id).color;
  }

  private gerarCorTags(tags): Tag[] {
    const cores = this.cores.get();
    let corAtual = 0;
    return tags.map((tag) => {
      tag.color = cores[corAtual];
      corAtual++;

      if (cores.length - 1 <= corAtual) {
        corAtual = 0;
      }
      return new Tag(tag);
    });
  }
}
